<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../../editable';
	import CheckmarkCircledOutline from '$lib/icons/checkmarkCircledOutline.svelte';

	interface Props {
		content: ISbStoryData<{
			items: Array<{ text: string; highlight?: boolean; description?: string }>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<hr class="mb-3 mt-4 border-t border-brown-5" />
	<ul class="flex flex-col gap-y-2 text-brown-1">
		{#each content.items as item}
			<li class="flex gap-x-2 text-[14px]/[160%] lg:text-[16px]/[150%]">
				<span class="inline-flex h-[1lh] items-center">
					<CheckmarkCircledOutline class={['h-4 w-4', { 'text-green-2': item.highlight }]} />
				</span>
				<span class="inline-block">
					<p class={{ 'text-green-2': item.highlight }}>
						{item.text}
					</p>
					{#if item.description && item.description.length > 0}
						<p class="text-brown-4">{item.description}</p>
					{/if}
				</span>
			</li>
		{/each}
	</ul>
</div>
